export const SIDE_BAR_ID = 'widget-menu-sidebar';
export const ACTIVE_SIDE_MENU_PARAM = 'sideMenu';
